import { render, staticRenderFns } from "./formattedMed.vue?vue&type=template&id=df6d2398"
import script from "./formattedMed.vue?vue&type=script&lang=js"
export * from "./formattedMed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports